// extracted by mini-css-extract-plugin
export default {"navbar":"MyNavbar_navbar__EaU9W","navlink":"MyNavbar_navlink__1P7fW","navlin":"MyNavbar_navlin__owYJc"};